(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mogofe-video-lite"] && !Shopify.designMode) return;
  try {
    if (!window.mogofeVideoLiteReady) {
    window.mogofeVideoLiteReady = true;

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('[data-mogofe-video-button]');
      if (!(button instanceof HTMLButtonElement)) return;

      const container = button.closest('[data-mogofe-video-lite]');
      const video = container?.querySelector('video');
      const source = video?.querySelector('[data-mogofe-video-source]');
      if (!(video instanceof HTMLVideoElement) || !(source instanceof HTMLSourceElement)) return;

      if (!source.src) {
        const videoUrl = source.dataset.src;
        if (!videoUrl) return;
        source.src = videoUrl;
        video.load();
      }

      button.hidden = true;
      video.hidden = false;
      video.play().catch(() => {});
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mogofe-youtube-lite"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.mogofeYouTubeLiteReady) return;
    window.mogofeYouTubeLiteReady = true;

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-mogofe-youtube-lite] > button');
      if (!(button instanceof HTMLButtonElement)) return;

      const root = button.closest('[data-mogofe-youtube-lite]');
      const videoId = root?.dataset.videoId?.replace(/[^A-Za-z0-9_-]/g, '');
      if (!(root instanceof HTMLElement) || !videoId || root.dataset.loaded === 'true') return;

      root.dataset.loaded = 'true';
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
      iframe.title = root.dataset.videoTitle || 'MOGOFE product video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.tabIndex = 0;
      root.replaceChildren(iframe);
      iframe.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
